<template>
    <el-popover
        style="border-radius: 12px!important;"
        placement="top-start"
        trigger="click"
        popper-class="popover-ai"
        :width="380"
        ref="aiPopover"
    >
        <div class="ai-container" :class="[step==='stream' ? 'is-stream' : '']">
        <div class="title-ai">
                <span style="display: flex; align-items: center">
                    <img  class="ic-light-dark" width="18px" @click="backToMenu" :src="require('@/assets/images/back-list.svg')"/>
                    <img src="@/assets/images/ai.svg" alt="ai">
                    <b class="sub-text">Tạo mail thông minh</b>
                </span>
               <span>
<!--                 <img v-if="step==='stream'" @click="stopAI" style="margin-right: 6px;" :src="require('@/assets/icons/Stop.svg')" alt="stop">-->
                 <img class="ic-light-dark"  width="18px" @click="closePopover" :src="require('@/assets/images/close.svg')" />
                                    </span>
            </div>
            <!-- ============= MENU CHỌN CHỨC NĂNG ============= -->
            <template v-if="step === 'menu'">
                <ul class="ai-menu">
                    <li @click="startInput(ACTION_AI_COMPOSE.COMPOSE_MAIL)">
                        {{ $t('zimbraNokey.composeNew') }}
                    </li>

                    <li @click="startDirectAction(ACTION_AI_COMPOSE.CUSTOM)">
                        {{ $t('zimbraNokey.customAI') }}
                    </li>

                    <li @click="startDirectAction(ACTION_AI_COMPOSE.SHORTER_MAIL)">
                        {{ $t('zimbraNokey.shorterMail') }}
                    </li>

                    <li @click="startDirectAction(ACTION_AI_COMPOSE.LONGER_MAIL)">
                        {{ $t('zimbraNokey.longerMail') }}
                    </li>

                    <li @click="startDirectAction(ACTION_AI_COMPOSE.FORMALIZE)">
                        {{ $t('zimbraNokey.formalize') }}
                    </li>

                    <li @click="startDirectAction(ACTION_AI_COMPOSE.TRANSLATE_EN)">
                        {{ $t('zimbraNokey.translateEn') }}
                    </li>

                    <li @click="startDirectAction(ACTION_AI_COMPOSE.STANDARD_FORMAT)">
                        {{ $t('zimbraNokey.standardFormat') }}
                    </li>
                </ul>
            </template>

            <!-- =================== INPUT BOX =================== -->
            <template v-else-if="step === 'input'">
                <div class="sub-feature">
                    "Tính năng hỗ trợ người dùng tạo, rút gọn, mở rộng, chuẩn hóa và dịch email một cách nhanh chóng. AI tự động phân tích nội dung, gợi ý câu từ phù hợp và tạo bố cục chuyên nghiệp, giúp việc soạn thảo trở nên dễ dàng và hiệu quả hơn."
                </div>
                <div class="ai-input-box">
                    <el-input
                        ref="inputBox"
                        type="textarea"
                        v-model="inputText"
                        :rows="2"
                        @keydown.native="handleKeydown"
                        placeholder="Nhập nội dung..."
                    />
                    <img src="@/assets/zimbra/images/send.svg" @click="runAI" alt="send">
<!--                        <el-button size="mini" type="primary" ">Run AI</el-button>-->
                </div>
            </template>

            <!-- ================== STREAMING ==================== -->
            <template v-else-if="step === 'stream'">
                <div class="chat-bubble user-bubble">
                    <img width="18px" :src="urlVopsAvatarLink" class="avatar" />
                    <div class="bubble-text">{{ inputText }}</div>
                </div>
                <div class="ai-stream-box">
<!--                    <div class="title-row">-->
<!--                        <el-button size="mini" type="text" @click="backToMenu">✕</el-button>-->
<!--                    </div>-->
                    <div class="ai-stream-output">
                        <div v-if="isStreaming" class="ai-loading">
                            <img :src="imgAI" class="icon">
                            <img :src="imgLoading" class="icon spin">
                        </div>
                        <div class="ai-content" v-html="streamOutput"></div>
                    </div>
                </div>
                <div class="btn-row ai-input-box">
                    <el-input
                        ref="inputBox"
                        type="textarea"
                        v-model="inputTextResult"
                        :rows="2"
                        @keydown.native="handleKeydown"
                        placeholder="Nhập nội dung..."
                    />

                    <!-- Nếu đang stream → hiện nút STOP -->
                    <img
                        v-if="step==='stream'"
                        src="@/assets/icons/Stop.svg"
                        @click="stopAI"
                        alt="stop"
                    />

                    <!-- Nếu không stream → hiện nút SEND -->
                    <img
                        v-else
                        src="@/assets/zimbra/images/send.svg"
                        @click="runAI"
                        alt="send"
                    />
                </div>
            </template>

            <!-- =================== RESULT ====================== -->
            <template v-else-if="step === 'result'">
                <div class="chat-bubble user-bubble">
                    <img width="18px" :src="urlVopsAvatarLink" class="avatar" />
                    <div class="bubble-text">{{ inputText }}</div>
                </div>
                <div class="ai-result-box">
                    <div class="float-actions" style="z-index: 1000">
                        <el-tooltip size="small" placement="top" content="Copy">
                            <span @click="handleCopyText"><el-icon class="el-icon-copy-document ic-ai"/></span>
                        </el-tooltip>
                        <el-tooltip size="small"  placement="top"  :content="$t('zimbra.zmMsg.zd_docQuickInsertTT')">
                            <span @click="insertToEditor"><el-icon style="margin: 0!important;" class="ic-ai el-icon-circle-plus"/></span>
                        </el-tooltip>
                    </div>
                    <div class="ai-stream-output-result" ref="streamBox" v-html="streamOutput">
                    </div>
                </div>
                <div class="btn-row ai-input-box">
                    <el-input
                        ref="inputBox"
                        type="textarea"
                        v-model="inputTextResult"
                        :rows="2"
                        @keydown.native="handleKeydown"
                        placeholder="Nhập nội dung..."
                    />

                    <!-- Nếu đang stream → hiện nút STOP -->
                    <img
                        v-if="step==='stream'"
                        src="@/assets/icons/Stop.svg"
                        @click="stopAI"
                        alt="stop"
                    />

                    <!-- Nếu không stream → hiện nút SEND -->
                    <img
                        v-else
                        src="@/assets/zimbra/images/send.svg"
                        @click="runAI"
                        alt="send"
                    />
                </div>
            </template>

        </div>

        <!-- ================= TRIGGER ICON ================= -->
        <template #reference>
            <div class="btn-mail-tool" style="transform: translateY(-4px)">
                <img src="@/assets/images/ai-border.svg" alt="ai">
            </div>
        </template>
    </el-popover>
</template>

<script>
import { ACTION_AI_COMPOSE } from "@/utils/constants";
import imgAI from "@/assets/images/ai.svg";
import imgLoading from "@/assets/images/loading.svg";
import AI from "@/assets/icons/AI.vue";
import CommonUtils from "@/utils/common-utils";

export default {
    name: "AiFeature",
    components: { AI },
    computed: {
        urlVopsAvatarLink(){
            return this.urlVopsAvatar()
        }
    },
    watch:{
      step(val){
          if(val !== null)
          this.updatePosition();
      }
    },

    data() {
        return {
            step: "menu",
            actionType: null,
            inputText: "",
            inputTextResult: "",
            streamOutput: "",
            isStreaming: false,
            controller: null,
            imgAI,
            imgLoading,
            selectedTextForCustom: "",
            ACTION_AI_COMPOSE
        };
    },

    methods: {
        insertToEditor() {
            this.$emit("insert-tiny", this.streamOutput);
            this.closePopover();
            // this.backToMenu();
        },

        handleCopyText: function() {
            const text = this.$refs.streamBox.innerText;
            navigator.clipboard.writeText(text)
                .then(() => this.$message({
                message: "Đã sao chép",
                type: "success"
            }))
                .catch(() => alert("Copy thất bại"));
        },
        handleKeydown(e) {
            if (this.isStreaming) return;
            // ALT + ENTER => xuống dòng
            if (e.altKey && e.key === "Enter") {
                e.preventDefault();
                const area = e.target;
                const start = area.selectionStart;
                const end = area.selectionEnd;

                this.inputText =
                    this.inputText.substring(0, start) +
                    "\n" +
                    this.inputText.substring(end);

                this.$nextTick(() => {
                    area.selectionStart = area.selectionEnd = start + 1;
                });

                return;
            }

            // ENTER => gửi AI
            if (e.key === "Enter") {
                e.preventDefault();
                this.runAI();
            }
        },
        updatePosition() {
            this.$nextTick(() => {
                this.$refs.aiPopover?.updatePopper();
            });
        },

        generateUniqueId() {
            return "ai-" + Math.random().toString(36).substring(2, 10);
        },
        urlVopsAvatar() {
            const BASE_AVT = 'https://vops.viettel.vn/avatar/';
            return `${BASE_AVT}${this.genUsernameFromEmail(CommonUtils.methods.getLocalStorageObject('zimbra_token')?.username)}`;
        },

        genUsernameFromEmail(email) {
            email = email?.toLowerCase();
            let [preAt, afterAt] = email?.split('@');
            let [dot1, dot2, dot3] = afterAt?.split('.');

            preAt = preAt?.toLowerCase() || preAt;
            if (afterAt === 'viettel.com.vn') { //Neu la email viettel
                return preAt;
            } else { //Neu la email viettelpost,...
                if (dot2 === 'com' && dot3 === 'vn') {
                    return `${preAt}_${dot1}`;
                } else {
                    return null;
                }
            }
        },
        backToMenu() {
            if (this.step == "menu"){
                this.closePopover();
            }
            this.step = "menu";
            this.inputText = "";
            this.streamOutput = "";
            this.isStreaming = false;
        },

        requireText(text) {
            if (!text?.trim()) {
                this.$message.warning(this.$t("zimbraNokey.noSelectedText"));
                return null;
            }
            return text;
        },

        /* ================= ACTIONS ================== */

        startInput(type) {
            this.actionType = type;
            this.inputText = "";
            this.step = "input";
            this.$nextTick(() => {
                const el = this.$refs.inputBox?.$el.querySelector("textarea");
                el?.focus();
            });
        },
        runDirectAction(type, selectedText) {
            this.actionType = type;
            // Nếu là CUSTOM → bắt buộc phải bôi đoạn text
            if (type === ACTION_AI_COMPOSE.CUSTOM) {

                if (!selectedText || selectedText.trim() === "") {
                    this.$message.warning(this.$t("zimbraNokey.noSelectedText"));
                    return;
                }

                // Lưu đoạn text đã bôi để lát runAI nối lại
                this.selectedTextForCustom = selectedText;

                // Mở ô input để user nhập prompt bổ sung
                this.inputText = "";
                this.step = "input";

                return;
            }

            // Còn lại các chức năng bình thường
            this.inputText = selectedText;
            this.runAI();
        },
        startDirectAction(type) {
            this.$emit("ai-stream", type)
        },

        /* ================== RUN AI ==================== */

        async runAI() {
            let textToSend = this.inputText;
            if (this.actionType === ACTION_AI_COMPOSE.CUSTOM) {

                if (!this.selectedTextForCustom) {
                    this.$message.warning(this.$t("zimbraNokey.noSelectedText"));
                    return;
                }

                if (!this.inputText?.trim()) {
                    this.$message.warning(this.$t("zimbraNokey.noPromptText"));
                    return;
                }
                textToSend = `${this.inputText} ${this.$t('zimbraNokey.for')}:  ${this.selectedTextForCustom}`;
            }
            // Nếu đang ở step result => dùng inputTextResult thay cho inputText
            if (this.step === 'result') {
                if (!this.inputTextResult?.trim()) return;

                textToSend = this.inputTextResult;      // dùng text mới
                this.inputText = this.inputTextResult;  // cập nhật text chính
                this.inputTextResult = "";              // clear input dưới
            }

            const ok = this.requireText(textToSend);
            if (!ok) return;

            this.step = "stream";
            this.streamOutput = "";
            this.isStreaming = true;

            const requestBody = {
                message: textToSend,
                action_name: this.actionType,
                sso_token: localStorage.getItem("token_sso")
            };

            await this.callAI(requestBody);
        },
        async stopAI() {
            if (this.controller) {
                this.controller.abort();
                this.isStreaming = false;
                this.step = "input";    // quay về state mong muốn
            }
         },

        /* ================= STREAM VIA SSE ================== */

        async callAI(message) {
            const maxRetry = 3;
            let attempt = 0;
            while (attempt < maxRetry) {
                try {
                    attempt++;
                    this.controller = new AbortController();
                    const requestId = this.generateUniqueId();
                    const res = await fetch(
                        `https://vmail.viettel.vn/api/ai/events/${requestId}`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "Accept": "text/event-stream"
                            },
                            body: JSON.stringify(message),
                            signal: this.controller.signal
                        }
                    );
                    if (!res.ok) {
                        console.warn(`HTTP ${res.status}, retry ${attempt}/${maxRetry}`);

                        if (attempt >= maxRetry) {
                            this.streamOutput =
                                "<span style='color:red'>Vui lòng nhập rõ yêu cầu của bạn. Trân trọng!</span>";
                            this.step = "result";
                            this.isStreaming = false;
                            return;
                        }

                        await new Promise(r => setTimeout(r, 600));
                        continue; //  quay lại while → retry
                    }

                    const reader = res.body.getReader();
                    const decoder = new TextDecoder();
                    let buffer = "";
                    let firstChunk = true;

                    while (true) {
                        const { done, value } = await reader.read();
                        if (done) break;

                        buffer += decoder.decode(value, { stream: true });
                        const parts = buffer.split("\n\n");
                        buffer = parts.pop();

                        for (const part of parts) {
                            const lines = part.trim().split("\n");
                            let eventName = null;
                            let dataJson = null;

                            for (const line of lines) {
                                if (line.startsWith("event:")) {
                                    eventName = line.replace("event:", "").trim();
                                }
                                if (line.startsWith("data:")) {
                                    const raw = line.replace("data:", "").trim();
                                    if (raw) {
                                        try {
                                            dataJson = JSON.parse(raw);
                                        } catch {}
                                    }
                                }
                            }

                            if (eventName === "end") {
                                this.isStreaming = false;
                                this.step = "result";
                                return; // ✅ thành công
                            }

                            if (dataJson?.content) {
                                if (firstChunk) {
                                    this.streamOutput = "";
                                    this.isStreaming = false;
                                    firstChunk = false;
                                }
                                this.streamOutput += dataJson.content;
                            }
                        }
                    }

                    return; // kết thúc stream OK

                } catch (e) {
                    console.error(`Call AI failed (attempt ${attempt})`, e);

                    // Abort → không retry
                    if (e.name === "AbortError") {
                        this.isStreaming = false;
                        return;
                    }
                }
            }
        },
        closePopover() {
            this.$refs.aiPopover?.doClose();
        }


    }
};
</script>

<style scoped lang="scss">
.popover-ai {
    padding: 0 !important;
}

.ai-container {
    min-height: 320px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title-ai{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #a6a6a6;
        margin-bottom: 8px;
        padding-bottom: 8px;
        img{
            cursor: pointer;
        }
        .sub-text{
            height: 28px;
            line-height: 30px;
            margin-left: 4px;
            align-content: center;
        }
    }
}

.ai-menu {
    flex-grow: 1;
    list-style: none;
    margin: 0;
    padding: 0;
}

.ai-menu li {
    padding: 10px 12px;
    cursor: pointer;
    transition: 0.15s ease;
    border-radius: 4px;
}

.ai-menu li:hover {
    color: var(--color-primary);
    //font-weight: 500;
    background: #f2f6fc;
}
.ai-input-box{
display: flex;
    align-items: center;
    gap: 1rem;
}
.ai-stream-box,
.ai-result-box {
    flex-grow: 1;
    padding-top: 6px;
    display: flex;
    position: relative;
    flex-direction: column;
    gap: 10px;
}

/* ----- Custom thanh scroll (Chrome / Edge / Safari / Opera) ----- */
.ai-stream-output-result::-webkit-scrollbar {
    width: 6px;
}

.ai-stream-output-result::-webkit-scrollbar-thumb {
    background: #bdbdbd;
    border-radius: 4px;
}

.ai-stream-output-result::-webkit-scrollbar-thumb:hover {
    background: #999;
}

.ai-stream-output-result::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 4px;
}


.ai-stream-output-result {
    padding: 16px 6px 2px 6px;
    white-space: normal;
    word-break: keep-all;
    overflow-wrap: break-word;   /* hoặc word-wrap: break-word */
    max-height: 200px;
    min-height: 200px;
    overflow-y: auto;
    flex-grow: 1;
    border-radius: 6px;
    overflow-x: hidden;
    /* giúp text không bị giật khi scroll */
    -webkit-overflow-scrolling: touch;

    /* padding cho nội dung đẹp hơn */}
.sub-feature{
    font-size: 11px;
    flex-grow: 1;
    white-space: normal;
    word-break: keep-all;
    overflow-wrap: break-word;
}
.btn-row {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 8px;
}
.ai-stream-output{
    background: #f3f3f3;
    border-radius: 6px;
    font-size: 12px;
    white-space: normal;
    word-break: keep-all;
    overflow-wrap: break-word;   /* hoặc word-wrap: break-word */
    max-height: 200px;
    min-height: 200px;
    overflow-y: auto;
    .ai-content{
        padding: 4px;
        border-radius: 4px;
        word-break: break-word;
        white-space: normal;
        overflow: hidden;
    }
}
.ai-result-box .ai-stream-output-result{
    font-size: 12px;
    background: #f3f3f3;
}
.chat-bubble {
    display: flex;
    align-items: flex-end;
    margin: 6px 0;
    max-width: 85%;
}

.user-bubble {
    flex-direction: row-reverse; /* avatar bên phải */
    margin-left: auto;           /* căn phải */
}

.avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    margin-left: 8px;
    object-fit: cover;
}

.bubble-text {
    background-color: var(--color-primary);
    color: #fff;
    padding: 4px 8px;
    border-radius: 12px 12px 0 12px;
    font-size: 12px;
    line-height: 1.2;

    word-break: break-word;
    white-space: normal;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    /* 👇 Một số browser cần max-height */
    max-height: calc(1.4em * 2);
}


.ai-loading {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px;
    margin-bottom: 8px;
    opacity: 0.7;
}
.icon {
    width: 22px;
    height: 22px;
}
:deep(.el-textarea__inner) {
     font-size: 12px;
     color: #333;
 }
.is-stream{
    justify-content: flex-start!important;
}
.ic-ai{
    cursor: pointer;
}
.ai-result-box:hover .float-actions {
    top: 3px;
    opacity: 1;
}

/* Floating buttons */
.float-actions {
    border-radius: 4px;
    padding: 2px;
    line-height: 20px;
    position: absolute;
    top: -4px;
    right: 6px;
    align-items: center;
    display: flex;
    gap: 6px;
    opacity: 0;
    transition: 0.2s ease;
    z-index: 1000000;
}


</style>
